import systemConfig from '../../../../config/systematic';
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space, Table } from 'antd';
import React, { useContext, useEffect, useState } from 'react'
import getList from '../../../universal/getList';
import fetchApi from '../../../../utils/api/fetchApi';
import dayjs from 'dayjs';
import { handleData } from './DailyReport';
import antMessage from '../../../../utils/extend/AntdNotification'
import DownloadExcel from '../../../report/DownloadExcel';
import { showCustomNotification, useNotificationInstance } from '../../../../utils/extend/AntdNotificationEx';
import { SocketContext } from '../../../../App';

const { RangePicker } = DatePicker;

export default function EnTrStatistics() {
  /** 后端数据wmService */
  let wmService: any = systemConfig.wmService;
  const [form] = Form.useForm();
  let isCurrentBranchStore = Form.useWatch("isCurrentBranchStore", form)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [user, setUser] = useState<any>("")
  const [deptData, setDeptData] = useState<any>();
  const [areaData, setAreaData] = useState<any>();

  const [deptModel, setDeptModel] = useState<any>([
    { id: "exDept", name: "调出部门" },
    { id: "imDept", name: "调入部门" },

  ])
  const useContextData = useContext(SocketContext);
  const { contextData, setContextData } = useContextData;
  const notificationApi = useNotificationInstance()

  const [productModel, setProductModel] = useState<any>([
    { id: "rangeNumSearch", name: "品号范围搜索" },
    { id: "similarNumSearch", name: "品号相似搜索" },
    { id: "equalNumSearch", name: "品号相等搜索" },
    { id: "similarNameSearch", name: "品名相似搜索" },
    { id: "equalNameSearch", name: "品名相等搜索" },



  ])
  const [sortOrder, setSortOrder] = useState<Array<any>>([
    { id: "ASC", name: "升序" },
    { id: "DESC", name: "降序" },

  ])
  const [sortType, setSortType] = useState<Array<any>>([
    { id: "selfId", name: "品号" },
    { id: "classificationWarehouseName", name: "分类" },
    { id: "productName", name: "品名" },


  ])
  const [selectProdutModel, setSelectProdutModel] = useState<any>("rangeNumSearch")

  const [queryCriteria, setQueryCriteria] = useState<any>("")
  const [classificationWarehouseData, setClassificationWarehouseData] = useState<any>();

  const [rows, setRows] = useState<any>([]);

  const [dataTypeData, setDataTypeData] = useState<Array<any>>();

  useEffect(() => {
    const fetchData = async () => {
      form.setFieldValue("chooseTime", [dayjs(), dayjs()])
      form.setFieldValue("productModel", "rangeNumSearch")
      form.setFieldValue("dataStatusType", 1)

      let deptData = await fetchApi.GET(wmService, {
        apiId: "dept",
        apiExtend: 'showList',
        apiData: {

        }
      })
      if (deptData.success) {
        setDeptData(deptData.data)
      }

      let areaData = await fetchApi.GET(wmService, {
        apiId: "area",
        apiExtend: 'showListManage',
        apiData: {
          mountDataOptions: {
            "userMount": {
              "isUserAreas": true,
              isDeptArea: true,
              isUserGroupAreas:true

            }
          },
        }
      })

      if (areaData.success) {
        setAreaData(areaData.data)
      }
      let classificationWarehouseData = await fetchApi.GET(wmService, {
        apiId: "classificationWarehouse",
        apiExtend: 'showList'
      })



      if (classificationWarehouseData.success) {

        setClassificationWarehouseData(classificationWarehouseData.data)
      }

      fetchApi.GET(wmService,
        {
          apiId: 'generalData',
          apiVariable: 'dataStatusType',
          apiExtend: 'showLists'
        }
      ).then(res => {
        if (res.success) {
          const { dataStatusType } = res.data


          setDataTypeData(dataStatusType)
        }
      })


    }
    fetchData()
  }, [])
  /** 表头内容 */
  let columnsHead: any = [

    {
      title: "品号",
      dataIndex: "selfId",
    },



    {
      title: "品名",
      dataIndex: "productName",
    },
    {
      title: "分类",
      dataIndex: "classificationWarehouseName",
    },
    {
      title: "单位",
      dataIndex: "productUnitName",
    },



    {
      title: "数量",
      dataIndex: "bNum",
    },
    {
      title: "均价",
      dataIndex: "univalence",
    },
    {
      title: "金额",
      dataIndex: "amount",
    },


  ]
  const onFinish = () => {
    setIsLoading(true)
    form.validateFields()
      .then(async (values: any) => {

        fetchApi.GET(wmService, {
          apiId: "entrepotReport",
          apiExtend: 'enTrStatistics',
          apiData: {
            ...values,
            time: values.chooseTime ? {
              startTime: dayjs(values.chooseTime[0]).format("YYYY-MM-DD"),
              endTime: dayjs(values.chooseTime[1]).format("YYYY-MM-DD"),
            } : null,
            selfs: values.selfStart && values.selfEnd ? {
              selfStart: values.selfStart,
              selfEnd: values.selfEnd
            } : null,
            selfId: values.selfId,
            productName: values.productName,
            entrepotId: contextData?.currentEntrepotId,
            deptModel: values.deptModel,
            productModel: values.productModel,
            isBigOrder: values.isBigOrder,
            mountDataOptions: {
              userMount: {
                isEmployees: true,
                isDept: true,
                isUserAreas: true,
                isUserGroupAreas: true
              }
            },
          }
        }).then((res: any) => {
          setIsLoading(false)
          setRows(res.data.rows)
          setQueryCriteria(res.data.queryCriteria)
          setUser(res.data.user)
          showCustomNotification(notificationApi!, {
            type: 'success',
            message: "搜索成功",
            description: "success"
          });;

        }).catch((err: any) => {
          console.log("err", err);
          setIsLoading(false)
          antMessage('error', '搜索失败', err.message + ' | status：' + err.errors.status);
        })
      })
      .catch((err) => {
        setIsLoading(false)
        showCustomNotification(notificationApi!, {
          type: 'warning',
          message: "无法通过数据校验",
          description: "请输入所需数据!"
        });;
      })





  }
  const changeProductModel = (e: any) => {
    setSelectProdutModel(e)


  }

  const onChangeBranchStore = (e: any) => {
    let checked = e.target.checked;

    if (checked) {
      fetchApi.GET(wmService, {
        apiId: "branchStore",
        apiExtend: 'getDeptByentrepot',
        apiData: {
          entrepotId: contextData?.currentEntrepotId

        }

      }).then((res: any) => {
        form.setFieldValue("deptIds", res.data)
      }).catch((err: any) => {
        form.setFieldValue("deptIds", [])
        console.log("err", err);


      })
    } else {
      form.setFieldValue("deptIds", [])
    }

  }
  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
      >
        <Row>
          <Col span={12}>
            <Form.Item
              label="部门"
              name="deptIds"
              rules={[{ required: isCurrentBranchStore ? false : true, message: '请选择部门!' }]}
            >
              <Select
                // orderTypeData
                mode="multiple"
                showSearch
                placeholder="请选择部门!"
                optionFilterProp="children"

                onSearch={(e) => getList.search('dept', setDeptData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(deptData, 'deptName')}
              </Select>
            </Form.Item>
          </Col>


          <Col span={6}>
            <Form.Item
              label="部门模式"
              name="deptModel"
              rules={[{ required: true, message: '请选择部门模式!' }]}
            >
              <Select
                showSearch
                placeholder="部门模式"
                optionFilterProp="children"

                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(deptModel, 'name')}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              label="调入区域"
              name="importAreaId"

            >
              <Select
                allowClear
                showSearch
                placeholder="调入区域"
                optionFilterProp="children"

                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(areaData, 'areaName')}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              label="产品模式"
              name="productModel"

            >
              <Select
                defaultValue={"rangeNumSearch"}
                onChange={changeProductModel}
                showSearch
                placeholder="产品模式"
                optionFilterProp="children"

                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(productModel, 'name')}
              </Select>
            </Form.Item>
          </Col>



          {
            selectProdutModel === "rangeNumSearch" ?
              <>
                <Col span={3}>
                  <Form.Item
                    label="品号"
                    name="selfStart"
                  >
                    <Input
                    />
                  </Form.Item>
                </Col>

                <Col span={3}>
                  <Form.Item
                    colon={false}
                    label="-"
                    name="selfEnd"
                  >
                    <Input

                    />
                  </Form.Item>
                </Col>
              </>
              : null
          }

          {
            selectProdutModel === "similarNameSearch" || selectProdutModel === "equalNameSearch" ?
              <>
                <Col span={3}>
                  <Form.Item
                    label="品名"
                    name="productName"
                  >
                    <Input />
                  </Form.Item>
                </Col>

              </>
              : null
          }
          {
            selectProdutModel === "similarNumSearch" || selectProdutModel === "equalNumSearch" ?
              <>
                <Col span={3}>
                  <Form.Item
                    label="品号"
                    name="selfId"
                  >
                    <Input />
                  </Form.Item>
                </Col>

              </>
              : null
          }
          <Col span={5}>
            <Form.Item
              label="品类"
              name="classificationWarehouses"
            >
              <Select
                mode="multiple"
                showSearch
                placeholder="品类"
                optionFilterProp="children"
                onSearch={(e) => getList.search('classificationWarehouse', setClassificationWarehouseData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(classificationWarehouseData, 'classificationWarehouseName')}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="排序类型"
              name="sortType"
            >
              <Select
                showSearch
                placeholder="排序类型"
                optionFilterProp="children"

              >
                {getList.general(sortType)}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="排序方式"
              name="sortOrder"
            >
              <Select
                showSearch
                placeholder="排序方式"
                optionFilterProp="children"

                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(sortOrder,)}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="日期"
              name="chooseTime"
            >
              <RangePicker
                defaultValue={[dayjs(), dayjs()]}
                format="YYYY-MM-DD"
              />
            </Form.Item>
          </Col>
          <Col span={1.5}>
            <Form.Item
              label="当前分店"
              name="isCurrentBranchStore"
              valuePropName="checked"

            >
              <Checkbox onChange={onChangeBranchStore}></Checkbox>
            </Form.Item>
          </Col>


          <Col span={1.5}>
            <Form.Item
              label="大单"
              name="isBigOrder"
              valuePropName="checked"

            >
              <Checkbox ></Checkbox>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="dataStatusType"
            >
              <Select
                defaultValue="数据状态"
                placeholder="数据状态"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(dataTypeData)}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item >
              <Space>
                <Button loading={isLoading} htmlType="submit">
                  统计
                </Button >
                <Button onClick={() => DownloadExcel(rows, "enTrStatistics", queryCriteria)}>下载EXCEL文件</Button>
                {/* <Button onClick={() => entrepotPrint.printEnReport(rows, "entrepotDailyReportPrint", queryCriteria, user)} >
                  打印
                </Button> */}
                {/* <Button onClick={() => entrepotPrint.printEnReport(rows, "entrepotDailyReportPrint", queryCriteria, user)} >
                  打印
                </Button> */}
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <div style={{ marginTop: "20px" }}>
        <Table
          scroll={{ x: "100%", y: 650 }}
          pagination={false}
          rowKey={(record: any, index: any) => {
            return index
          }}
          columns={columnsHead}
          dataSource={rows}

        >
        </Table>

      </div>
    </>
  )
}
